module.exports = __webpack_public_path__ + "img/edit_task.a54ff034.svg";